import { Grid, TextInput, Checkbox, Typography } from '@ts/storybook';
import { WrapperEntitySelector } from '@components/Inputs';
import { useMemo } from 'react';
import { CEntity, IEntity, IForm } from '@ts/ui-models';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { NewPaperWithPadding } from '@components/Misc';

interface IEventTypeDistributionsTabProps extends IForm {
  quickFindInit?: any;
}

const EventTypeDistributionsTab = (props: IEventTypeDistributionsTabProps) => {
  const { values, onCallbackChange } = props;
  const isDisabled = useMemo(() => props.mode === 'view' || !values.distributes, [props.mode, values]);

  const onChangeGeneric = (model: CEntity<IEntity> | null, entity: string) => {
    if (model != null) {
      onCallbackChange(entity + 'Id')(model.getID());
      onCallbackChange(entity)(model);
    } else {
      onCallbackChange(entity + 'Id')(null);
      onCallbackChange(entity)(null);
    }
  };

  const renderEmailParameters = (type: 'export' | 'distribution') => {
    return (
      <>
        <TextInput
          isReadOnly={isDisabled}
          label="E-mail subject"
          value={values.distributionSubject}
          onChangeValue={onCallbackChange(type === 'distribution' ? 'distributionSubject' : 'exportationSubject')}
          style={{ width: '50%' }}
        />
        <TextInput
          isReadOnly={isDisabled}
          label="E-mail body"
          value={values.distributionBody}
          onChangeValue={onCallbackChange(type === 'distribution' ? 'distributionBody' : 'exportationBody')}
          minRows={3}
          maxRows={3}
          multiline
        />
      </>
    );
  };

  return (
    <Grid container>
      <NewPaperWithPadding>
        <Grid container spacing={2} direction={'column'}>
          <Typography variant="h6" text="Distribution configuration" className="mb-2" />
          <Checkbox
            disabled={props.mode === 'view'}
            checked={values.distributes}
            onChangeValue={onCallbackChange('distributes')}
            label="Distribute"
          />
          {values.distributes && (
            <Grid container spacing={8} direction="row" alignItems="flex-start">
              <Grid size={{ xs: 12, md: 4 }}>
                <WrapperEntitySelector
                  label={'Distribution Configuration'}
                  searchComponent={generateSearchEntitySelector('distributionConfiguration')}
                  value={values.distConf || values.distConfId}
                  onChangeEntity={d => onChangeGeneric(d, 'distConf')}
                  isReadOnly={isDisabled}
                  multiple={false}
                  required={!isDisabled && !values.distConf}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 8 }}>{renderEmailParameters('distribution')}</Grid>
            </Grid>
          )}
        </Grid>
      </NewPaperWithPadding>
    </Grid>
  );
};

export default EventTypeDistributionsTab;
